import React from 'react';

export const translations = {
    en: {
        readyToConnect: "You're About to Connect!",
        greatNews: "Great news! You're about to exchange contact information. This is the first step toward building a successful partnership. 🎉",
        quickReminder: "A QUICK REMINDER",
        reportOrderReminder: "If this connection leads to an order, please report it back to us on the platform by clicking the \"Report Order\" button next to inbox.",
        platformSafety: "It keeps our platform safe from scams, enables you to receive verified reviews and builds your trust score (plus, it's part of our community guidelines).",
        transparencyNote: "Transparency makes the magic happen—thanks for being a part of Nearshore!",
        cancel: "Cancel",
        shareContactInfo: "Share contact info",
        readyToExchange: "Ready to exchange contact info?",
        secureExperience: "We are committed to ensuring that your experience with our nearshoring platform is secure and transparent.",
        pleaseAgree: "Please agree to our",
        termsAndConditions: "Terms and Conditions",
        toProceed: "to proceed.",
        agreeToTerms: "Agree to exchange contact info",
        shortAgree: "Agree",
        isReadyToExchange: "is ready to exchange contact info with you!",
        optIn: "Opt in by agreeing to our",
        thankYou: "Thank you for agreeing to the Platform Terms.",
        rememberToReport: "Remember, if an order occurs, press the Report Order button.",
        hitEnterToSend: "Write a message... (Ctrl + Enter to send)",
        pleaseRespondToRequest: "Please respond to the pending request before sending more messages",
        supplierPendingIntroRequest: "Your Introduction Request is Pending. Once accepted, you'll be able to reply!",
        attachRFQ: "Attach RFQ",
        send: "Send",
        createFirstRFQ: "Create your first RFQ",
        attachOneRFQ: "Attach one of your RFQs",
        createAndSubmit: "Create and submit an RFQ to attach it to a conversation.",
        attach: "Attach",
        toShowContactInfoTo: "with",
        theOtherParty: "the other party",
        modalAgreeToTerms: "Agree to terms",
        shareFile: "Share file",
        startZoomCall: "Start Zoom call",
        introCenterTitle: "Introduction Center",
        introCenterSubtitle: "When you mark a project as interested, our team will be notified and we'll connect you with the buyer if it's a good fit.",
        filterByCategory: "Filter by category",
        allProjects: "All Projects",
        myProjects: "My projects",
        interestButtonLabel: "I'm interested",
        projectName: "Project Name",
        category: "Category",
        interest: "Interest",
        paywallTitle: "You've Used Your Free Intros",
        paywallSubscribedTitle: "You've used your Introduction Credit for this month",
        paywallTopVerifiedTitle: "You've reached your intro request limit",
        paywallTopVerifiedSubtitle: "Your account comes with 30 Introduction Requests per month",
        paywallTopVerifiedItem1: "Your next request will be available on",
        paywallTopVerifiedItem2: "You have the highest search ranking and verified badge",
        paywallTopVerifiedItem3: "Premium support and priority review of your requests",
        paywallSuscribedSubtitle: "Upgrade to unlock more introductions and connect with more buyers.",
        paywallSubtitle: "You get one product intro per month for free — upgrade to unlock up to 30 intros per month and connect with more brands.",
        paywallItem1: "You get from 10 to 30 RFQ Bids per month on paid plans",
        paywallSubscribedItem1: "You get 10 intros with a Verified plan and up to 30 per month with the Vetted AI+ plan",
        paywallItem2: "Boost your factory profile with the highest search ranking",
        paywallSubscribedItem2: "Boost your factory profile with the highest search ranking and verified badge",
        paywallItem3: "Message other suppliers and pitch your company to brands",
        paywallSubscribedItem3: "Access to Factory Search to source materials and subcontractors",
        paywallButton: "Explore our plans",
        reachOutTitle: "You're About to Reach Out",
        reachOutSubtitle: "You're expressing interest in connecting with this brand. Let them know why you're a great fit.",
        reachOutHelperText: "Share a quick note about your factory, capabilities, or relevant experience.",
        creditsAvailable: " ",
        submitForCredit: "Submit",
        submit: "Submit",
        requestSent: "Request Sent",
        introMade: "Intro Made",
        removeInterest: "Remove Interest",
        cancelRequest: "Cancel",
        introductionRequest: "Introduction Request",
        waitingForResponse: "Waiting for response",
        requestDeclined: "An introduction request has been declined because it is not a good fit for the project",
        requestRemoved: "An introduction request has been removed because it is no longer active",
        requestReported: "Your report has been received: thank you for helping us keep Nearshore safe.",
        reportOp1: "Inaccurate or misleading information",
        reportOp2: "Inappropriate content or behavior",
        reportOp3: "Suspicious activity or spam",
        reportOp4: "Intellectual property concern",
        reportOp5: "Doesn't match our capabilities",
        reportOp6: "Other",
        reportPlaceholder: "Please Explain",
        reportTitle: "Report Profile",
        reportSubtitle: "Help us keep Nearshore safe and trustworthy.",
        reportSubtitleContinue: "Let us know why you're reporting this factory:",
        declinedRequest: "Decline request",
        message: "Message:",
        thankYouForReport: "Thank you for your report. We'll review it shortly.",
        upgradeToAccept: "Upgrade to accept",
        acceptRequest: "Accept",
        acceptIntroduction: "Accept introduction",
        respondToPendingFirst: "Please respond to your pending introduction requests",
        yourTopMatches: "Your Top Matches",
        topMatchesExplanation: "We've gathered these based on your factory profile. To improve matches, update your categories and MOQ in your profile.",
        edit: "Edit",
        invoice: {
            buttonLabel: "Send an Invoice",
            title: "New Invoice",
            reviewTitle: "Review Invoice",
            viewAndPay: "View and Pay",
            companyAddress: "COMPANY ADDRESS",
            orderNumber: "Invoice number (optional)",
            productDescription: "Product description",
            qty: "Quantity",
            price: "Price",
            subtotal: "Subtotal",
            tax: "Tax",
            totalEstimate: "Invoice total",
            saveAndReview: "Save and Review",
            orderNotes: "Notes (optional)",
            productDescriptionPlaceholder: "Insert product name",
            orderNotesPlaceholder: "Add any additional notes, payment instructions, etc. here",
            customerAddress: "Customer address",
            orderNo: "Invoice #",
            dateSent: "Date sent",
            customerInfo: "Customer info",
            messageTitle: "Invoice",
            detailTitle: "Invoice",
            orderNumberUnavailable: "Invoice number already in use",
            from: "From",
            to: "To",
            lineItems: "Line Items",
            invoiceNumber: "Invoice #",
            invoiceDate: "Invoice date",
            invoiceTotal: "Invoice Total",
            invoiceStatus: "Invoice Status",
            paymentInstructions: "Payment Instructions",
            notes: "Notes",
            memo: "Memo",
            total: "Total",
            dueDate: "Due Date",
            orderItems: "Order Items",
            productError: "Description can't be blank",
            priceError: "Price must be greater than 0",
            quantityError: "Quantity must be greater than 0",
            noActiveConversation: "Unable to create an invoice without an active conversation. Please wait until the other party replies.",
            payInvoice: "Pay Invoice",
            paid: "Paid",
            viewReceipt: "View Receipt",
            processing: "Processing...",
            paymentProcessingNote: "Payment is being processed. Please wait or refresh to see updated status.",
            addItem: "Add Item",
            itemSingular: "item",
            itemPlural: "items",
        },
        view: "View",
        introCenter: {
            noAiMatchesFound: "No AI matches found yet",
            aiMatchingDescription: "Our AI system matches you with relevant projects based on your profile. Complete these sections to improve your matches:",
            aiInfoTitle: "Basic Information",
            aiInfoSubtitle: "Company details, location, and contact info",
            aiCapabilitiesTitle: "Capabilities",
            aiCapabilitiesSubtitle: "Services you offer and production capacity",
            aiProductTypesTitle: "Product Types",
            aiProductTypesSubtitle: "What you manufacture and specialize in",
            aiImagesTitle: "Images",
            aiImagesSubtitle: "Factory photos and product samples",
        },
        attributeTag: {
            highMoq: "High MOQ",
            urgentRequest: "Urgent request",
            premiumBrand: "Premium Brand",
        },
        capabilities: {
            productDesign: "Product Design",
            production: "Production",
            materials: "Materials",
            packingAndFulfillment: "Packing and Fulfillment",
        },
        inbox: {
            filters: {
                selectStatus: "Select Status",
                all: "All",
                discussingProject: "Discussing Project",
                quoting: "Quoting",
                sampling: "Sampling",
                production: "Production",
                notAFit: "Not a Fit",
                closed: "Closed",
                default: "active",
                pending: "Pending",
                declined: "Declined",
                accepted: "Accepted",
            },
            filterByStatus: "Filter by status",
            reportOrder: "Report Order",
            searchPlaceholder: "Search conversations or RFQs",
            messages: "Messages",
            pinned: "Pinned",
            download: "Download",
            view: "View",
            viewProfile: "View Profile",
            menu: {
                settings: "Settings",
                plans: "Plans",
                helpCenter: "Help Center",
            },
            months: "mo",
            justNow: "just now",
            ago: "ago"
        },
        brandSignup: {
            step1: {
                title1: "Create a free Nearshore account",
                title2: "",
                Luna: [
                    "Here's what you get when you join:",
                    "✓ Access 5000+ vetted factories in the Americas and Europe",
                    "✓ Get matched based on your product",
                    "✓ Start your sourcing project instantly",
                ],
                LunaEmailError: [
                    "Let's try again!",
                    "I'll need a valid email and password to connect you with factories + leads.",
                    "Make sure you are using the correct format.",
                    <span>Think you already may have an account? <a href="/login">Sign in here</a>.</span>
                ],
                LunaEmailTakenError: [
                    "Oops! This email is already registered.",
                    "Please use a different email or log in to your existing account.",
                ],
                emailLabel: "What's your email?",
                emailPlaceholder: "your-brand-email@example.com",
                passwordLabel: "Choose a password (6 characters minimum)",
                passwordPlaceholder: "••••••••",
                nextStepsInfo: "After signing up, you'll set up your first project or jump straight to your dashboard.",
                joinButtonLabel: "Join for free",
                or: "or",
                googleButtonLabel: "Sign up with Google",
                termsNoticePrefix: "By signing up you agree to",
                termsAndConditions: "terms and conditions",
                privacyPolicy: "privacy policy",
            },
            stepProject: {
                Luna: [
                    (name) => `Welcome, ${name}!`,
                    "Now, let's get back to your product...",
                ],
                projectNameLabel: "Name your project",
                projectNamePlaceholder: "e.g., Custom leather handbags",
                categoryLabel: "What category does your product fit into?",
                projetInputPlaceholder: "Add a product name",
                projectInputCategory: "Add de product category",
                projectHelper: "Tell us the specific product type",
                urgency: "What is your level of urgency?",
                urgencyOptions: [
                    { key: "not_sure", label: "Not sure" },
                    { key: "getting_quotes", label: "Getting quotes and pricing" },
                    { key: "need_supplier_asap", label: "Need a new Supplier ASAP" },
                ],
                lastStep: "Last step is next...",
                selectCategory: "Select a category",
            }
        },
        noimages: "No images to display",
        brandRfq: {
            aiChat: {
                loading: "Loading...",
                error: (error) => `Error: ${error?.message || 'No RFQ data available'}`,
                selectCategory: "Select Category",
                selectIdealOrderQuantityMessage: "Setting a desired order quantity is very important to attract suppliers.",
                selectIdealOrderQuantity: "Select Ideal Order Quantity",
                selectLocation: "Select Location",
                selectLocationMessage: "It's also important to select a prefered location for the manufacturing.",
                certificationsMessage: "You can also select what certifications are important to you.",
                selectCertifications: "Select Certifications",
                urgencyMessage: "What is your level of urgency?",
                urgencyOptions_not_sure: "Not sure",
                urgencyOptions_getting_quotes: "Getting quotes and pricing",
                urgencyOptions_need_supplier_asap: "Need a new Supplier ASAP",
            },
            billOfMaterials: {
                title: "Bill of Materials",
                subtitle: "Details on exactly which capabilities and processes are needed.",
                cardSubtitle: "Specifications",
                quantityNeeded: "Quantity Needed per product",
            },
            sourcingNeeds: {
                title: "Sourcing Needs",
                subtitle: "Details on exactly which capabilities and processes are needed.",
                cardTitle: "Sourcing Need",
                noDescription: "No description provided",
            },
            rfqInfoTable: {
                needs: "Needs",
                desiredOrderQuantity: "Desired Order Quantity",
                category: "Category",
                subCategory: "Sub Category",
                locationPreferences: "Location Preferences",
                desiredCertifications: "Desired Certifications",
            },
            withAI: {
                title: "Lets make sure everything looks correct",
                subtitle: "Here’s exactly what vetted factories will see. Make sure it looks right before sending.",
                aboutTheCompany: "About the company",
                yearsInBusiness: "Years in business",
                businessSize: "Business size",
                marketSegment: "Market segment",
                similarBrands: "Similar brands",
                loading: "Loading...",
                urgentRequest: "Urgent request",
                highMoq: "High MOQ",
                viewAll: "View All",
                downloadAll: "Download All",
                addFiles: "Add files",
                uploading: "Uploading...",
            },
            noAi: {
                submissionLimit: (rfqLimitTracker) => `RFQ Submission Limit - ${rfqLimitTracker.tier_name} Plan`,
                upgradeYourPlan: "Upgrade your plan",
                submitMoreRFQs: "to submit more RFQs",
                createProductRFQ: "Nearshore RFQ",
                tellUsAboutYourProduct: "From concept to production — start your sourcing request here",
                projectName: "Project name",
                category: "Category",
                selectCategory: "Select a category",
                help: "Choose the main category for your product",
                subcategory: "Subcategory",
                selectSubcategory: "Select a subcategory",
                getSpecific: "Let's get specific!",
                productDescription: "Product description",
                whatDoYouNeedHelpWith: "What do you need help with?",
                needHelpSubtitle: "Tell us what services you need help with to complete your product.",
                doYouHaveYourProductDesignCompleted: "Do you have your product design completed?",
                serviceDescription: "Specifications, drawings, sample etc.",
                details: "Details...",
                productionServicestitle: "Are you looking for production services?",
                productionServiceDescription: "Cut/sew, assembly, fabrication etc.",
                yes: "Yes",
                no: "No",
                sourceMaterialsTitle: "Do you need to source materials for this product?",
                sourceMaterialsDescription: "Select 'no' if you have existing materials sources.",
                packagingSupportTitle: "Do you need packaging support?",
                packagingSupportDescription: "Packaging design, ordering packaging and/or shipping materials etc.",
                filesTechPacksAndDesignDocumentsTitle: "Files, Tech Packs, and Design Documents",
                filesTechPacksAndDesignDocumentsDescription: "If you have them, upload any specifications, renderings, or other design documentation to help source your product.",
                inspirationImagesTitle: "Inspiration Images",
                inspirationImagesDescription: "Upload at least one image to submit with your RFQ. This can be an inspiration image of a similar product, a sample image, a drawing etc. The more the better",
                billOfMaterialsTitle: "Bill of materials",
                billOfMaterialsDescription: "Please provide a complete list of the materials required to make your product.",
                materialName: "Material name",
                materialDescription: "Description",
                materialSpecifications: "Specifications",
                materialQuantityNeeded: "Quantity needed per product",
                attributeTitle: "Attribute",
                priorityLow: "Low priority",
                priorityNiceToHave: "Nice to have",
                priorityNonNegotiable: "Non Negotiable",
                capabilitiesTitle: "Desired Services and Capabilities",
                capabilitiesDescription: "What the factory must be able to do—e.g. screen printing, metal casting, embroidery. Helps us filter for the right partners.",
                enterDesiredServiceOrCapability: "Enter a desired service or capability",
                addCapability: "Add capability",
                additionalDetailsTitle: "Additional details",
                additionalDetailsDescription: "Optional details to scope the job.",
                selectLocation: "Select location",
                selectManufacturingRegion: "Select your preferred manufacturing region.",
                desiredOrderQuantity: "Desired order quantity",
                howManyUnitsYouPlanToProduce: "How many units you plan to produce.",
                idealPriceYouWouldLikeToPayPerUnit: "The ideal price you'd like to pay per unit.",
                helpsFactoriesAlignOnMaterialsAndPricing: "Helps factories align on materials + pricing",
                whereWillYourGoodsBeShipped: "Where will your goods be shipped?",
                optionalSpecialInstructions: "Optional special instructions...",
                optionalSpecialInstructionsPlaceholder: "Special packing or shipping instructions...",
                productContextTitle: "Product context",
                productContextDescription: "Details about what you're sourcing and how it's positioned.",
                selectMarketSegment: "Select market segment",
                weWillMatchYouWithFactoriesThatServeThisMarket: "We'll match you with factories that serve this market.",
                factoriesMayAlsoMake: "Factories may also make....",
                factoriesMayAlsoMakePlaceholder: "Optional keywords to refine factory type...",
                factoriesToAvoid: "Factories to avoid",
                listIfApplicable: "List if applicable",
                referenceBrands: "Reference brands",
                factoryPreferencesTitle: "Factory preferences",
                factoryPreferencesDescription: "We'll filter for factories that meet your compliance or quality standards.",
                weWillFilterForYourNeeds: "We'll filter for your needs.",

            },
            certificationsTags:{
                selectMultiple: "Select multiple",
            }

        }
    },
    es: {
        readyToConnect: "¡Estás a punto de conectarte!",
        greatNews: "¡Buenas noticias! Estás a punto de intercambiar información de contacto. Este es el primer paso para construir una asociación exitosa. 🎉",
        quickReminder: "UN RECORDATORIO RÁPIDO",
        reportOrderReminder: "Si esta conexión conduce a un pedido, infórmenos en la plataforma haciendo clic en el botón \"Reportar Pedido\" junto a la bandeja de entrada.",
        platformSafety: "Mantiene nuestra plataforma segura contra estafas, te permite recibir reseñas verificadas y construye tu puntaje de confianza (además, es parte de nuestras pautas comunitarias).",
        transparencyNote: "¡La transparencia hace que la magia suceda, gracias por ser parte de Nearshore!",
        cancel: "Cancelar",
        shareContactInfo: "Compartir información de contacto",
        readyToExchange: "¿Listo para intercambiar información de contacto?",
        secureExperience: "Estamos comprometidos a garantizar que tu experiencia con nuestra plataforma nearshoring sea segura y transparente.",
        pleaseAgree: "Por favor, acepta nuestros",
        termsAndConditions: "Términos y Condiciones",
        toProceed: "para continuar.",
        agreeToTerms: "Aceptar intercambiar información de contacto",
        shortAgree: "Aceptar",
        isReadyToExchange: "está listo para intercambiar información de contacto contigo!",
        optIn: "Acepta nuestros",
        thankYou: "Gracias por aceptar los términos de la plataforma.",
        rememberToReport: "Recuerda, si ocurre un pedido, presiona el botón de reportar pedido.",
        hitEnterToSend: "Escribe un mensaje... (Ctrl + Enter para enviar)",
        pleaseRespondToRequest: "Por favor, responde a la solicitud pendiente antes de enviar más mensajes",
        supplierPendingIntroRequest: "Tu Solicitud de Introducción está Pendiente. ¡Una vez aceptada, podrás responder!",
        attachRFQ: "Adjuntar RFQ",
        send: "Enviar",
        createFirstRFQ: "Crea tu primer RFQ",
        attachOneRFQ: "Adjunta uno de tus RFQs",
        createAndSubmit: "Crea y envía un RFQ para adjuntarlo a una conversación.",
        attach: "Adjuntar",
        toShowContactInfoTo: "con",
        theOtherParty: "la otra parte",
        modalAgreeToTerms: "Aceptar términos",
        shareFile: "Compartir archivo",
        introCenterTitle: "Centro de presentaciones",
        introCenterSubtitle: "Cuando marques que un proyecto te interesa, nuestro equipo será notificado y te contactaremos con el comprador si cumple con sus necesidades",
        filterByCategory: "Filtrar por categoría",
        allProjects: "Todos los proyectos",
        myProjects: "Mis proyectos",
        interestButtonLabel: "Me interesa",
        projectName: "Nombre del proyecto",
        category: "Categoría",
        interest: "Interés",
        paywallTitle: "Has utilizado tus Intros Gratis",
        paywallSubscribedTitle: "Has utilizado tus Créditos de Introducción para este mes",
        paywallTopVerifiedTitle: "Has alcanzado tu límite de solicitudes de introducción",
        paywallTopVerifiedSubtitle: "Tu cuenta incluye 30 solicitudes de introducción por mes",
        paywallTopVerifiedItem1: "Tu próxima solicitud estará disponible el",
        paywallTopVerifiedItem2: "Tienes el ranking de búsqueda más alto y badge verificado",
        paywallTopVerifiedItem3: "Soporte premium y revisión prioritaria de tus solicitudes",
        paywallSuscribedSubtitle: "Actualiza tu plan para desbloquear Intros ilimitadas y conectar con más marcas.",
        paywallSubtitle: "Obtendrás una introducción de producto por mes de forma gratuita - actualiza para desbloquear hasta 30 introducciones por mes y conectarte con más marcas.",
        paywallItem1: "Obtén de 10 a 30 solicitudes de cotización por mes con nuestros planes pagos",
        paywallSubscribedItem1: "Obtén 10 introducciones con un plan Verificado y hasta 30 por mes con el plan Top Verificado",
        paywallItem2: "Impulsa tu perfil de fábrica con el mejor ranking de búsqueda",
        paywallSubscribedItem2: "Impulsa tu perfil de fábrica con el mejor ranking de búsqueda y la insignia de verificación",
        paywallItem3: "Envía mensajes a otros proveedores y presenta tu empresa a marcas",
        paywallSubscribedItem3: "Accede a la busqueda de fábricas  para buscar materiales y subcontratistas",
        paywallButton: "Explora nuestros planes",
        reachOutTitle: "Estás a punto de ponerte en contacto",
        reachOutSubtitle: "Estás mostrando interés en conectar con esta marca. Hazles saber por qué eres una excelente opción.",
        reachOutHelperText: "Comparte una breve descripción de tu fábrica, tus capacidades y tus experiencias relevantes.",
        creditsAvailable: "",
        startZoomCall: "Iniciar una llamada de Zoom",
        submitForCredit: "Enviar",
        submit: "Enviar",
        requestSent: "Solicitud Enviada",
        introMade: "Introducción realizada",
        removeInterest: "Quitar interés",
        cancelRequest: "Cancelar",
        introductionRequest: "Solicitud de introducción",
        waitingForResponse: "Esperando respuesta",
        requestDeclined: "Una solicitud de introducción ha sido rechazada porque no es adecuada para el proyecto",
        requestRemoved: "Una solicitud de introducción ha sido eliminada porque ya no está activa",
        requestReported: "Tu reporte ha sido recibido: gracias por ayudarnos a mantener Nearshore seguro.",
        reportOp1: "Información inexacta o engañosa",
        reportOp2: "Contenido o comportamiento inapropiado",
        reportOp3: "Actividad sospechosa o spam",
        reportOp4: "Problema de propiedad intelectual",
        reportOp5: "No coincide con nuestras capacidades",
        reportOp6: "Otro",
        reportPlaceholder: "Por favor, explica",
        reportTitle: "Reportar perfil",
        reportSubtitle: "Ayúdanos a mantener Nearshore seguro y confiable.",
        reportSubtitleContinue: "Cuéntanos por qué estás reportando este perfil:",
        declinedRequest: "Rechazar solicitud",
        message: "Mensaje:",
        thankYouForReport: "Gracias por tu reporte. Lo revisaremos pronto.",
        upgradeToAccept: "Pasa a premium para aceptar",
        acceptRequest: "Aceptar",
        acceptIntroduction: "Aceptar introducción",
        respondToPendingFirst: "Por favor responde a tus solicitudes de introducción pendientes",
        yourTopMatches: "Tus Mejores Coincidencias",
        topMatchesExplanation: "Las hemos recopilado basándonos en el perfil de tu fábrica. Para mejorar las coincidencias, actualiza tus categorías y MOQ en tu perfil.",
        invoice: {
            buttonLabel: "Enviar una factura",
            title: "Nueva factura",
            reviewTitle: "Revisar factura",
            viewAndPay: "Ver y pagar",
            companyAddress: "DIRECCIÓN DE LA EMPRESA",
            orderNumber: "Número de factura (opcional)",
            productDescription: "Descripción del producto",
            qty: "Cantidad",
            price: "Precio",
            subtotal: "Subtotal",
            tax: "Impuesto",
            totalEstimate: "Total de la factura",
            saveAndReview: "Guardar y revisar",
            orderNotes: "Notas (opcional)",
            productDescriptionPlaceholder: "Ingresa el nombre del producto",
            orderNotesPlaceholder: "Agregue notas adicionales, instrucciones de pago, etc. aquí",
            customerAddress: "Dirección del cliente",
            orderNo: "Factura #",
            dateSent: "Fecha de envío",
            customerInfo: "Información del cliente",
            messageTitle: "Factura",
            detailTitle: "Factura",
            orderNumberUnavailable: "El número de factura ya está en uso",
            from: "De",
            to: "A",
            lineItems: "Artículos",
            invoiceNumber: "Factura #",
            invoiceDate: "Fecha de la factura",
            invoiceTotal: "Total de factura",
            invoiceStatus: "Estado de factura",
            paymentInstructions: "Instrucciones de pago",
            notes: "Notas",
            memo: "Memo",
            total: "Total",
            dueDate: "Fecha de vencimiento",
            orderItems: "Artículos",
            productError: "La descripción no puede estar en blanco",
            priceError: "El precio debe ser mayor que 0",
            quantityError: "La cantidad debe ser mayor que 0",
            noActiveConversation: "No se puede crear una factura sin una conversación activa. Espere hasta que la otra parte responda.",
            payInvoice: "Pagar factura",
            paid: "Pagada",
            viewReceipt: "Ver recibo",
            processing: "Procesando...",
            paymentProcessingNote: "El pago se está procesando. Espere o actualice para ver el estado.",
            addItem: "Agregar artículo",
            itemSingular: "artículo",
            itemPlural: "artículos",
        },
        view: "Ver",
        introCenter: {
            noAiMatchesFound: "No se encontraron coincidencias de IA aún",
            aiMatchingDescription: "Nuestro sistema de IA te empareja con proyectos relevantes basándote en tu perfil. Completa estas secciones para mejorar tus coincidencias:",
            aiInfoTitle: "Información básica",
            aiInfoSubtitle: "Detalles de la empresa, ubicación y contacto",
            aiCapabilitiesTitle: "Capacidades",
            aiCapabilitiesSubtitle: "Servicios que ofreces y capacidad de producción",
            aiProductTypesTitle: "Tipos de productos",
            aiProductTypesSubtitle: "Lo que fabricas y especializas",
            aiImagesTitle: "Imágenes",
            aiImagesSubtitle: "Fotos de tu fábrica y muestras de productos",
        },
        attributeTag: {
            highMoq: "MOQ alto",
            urgentRequest: "Solicitud urgente",
            premiumBrand: "Marca premium",
        },
        capabilities: {
            productDesign: "Diseño de producto",
            production: "Producción",
            materials: "Materiales",
            packingAndFulfillment: "Empaquetado y envío",
        },
        inbox: {
            filters: {
                selectStatus: "Seleccionar estado",
                all: "Todos",
                discussingProject: "Discutiendo proyecto",
                quoting: "Cotización",
                sampling: "Muestreo",
                production: "Producción",
                notAFit: "No Encaja",
                closed: "Cerrado",
                default: "activo",
                pending: "Pendiente",
                declined: "Rechazado",
                accepted: "Aceptado",
            },
            filterByStatus: "Filtrar por estado",
            reportOrder: "Orden de informe",
            searchPlaceholder: "Buscar conversaciones o RFQs",
            messages: "Mensajes",
            pinned: "Fijado",
            download: "Descargar",
            view: "Ver",
            viewProfile: "Ver perfil",
            menu: {
                settings: "Configuración",
                plans: "Planes",
                helpCenter: "Centro de ayuda",
            },
            months: "me",
            justNow: "justo ahora",
            ago: "atrás"
        },
        brandSignup: {
            step1: {
                title1: "Crea una cuenta gratuita de Nearshore",
                title2: "",
                Luna: [
                    "Esto es lo que obtienes al unirte:",
                    "✓ Acceso a más de 5000 fábricas verificadas en las Américas y Europa",
                    "✓ Emparejamiento basado en tu producto",
                    "✓ Inicia tu proyecto de sourcing al instante",
                ],
                LunaEmailError: [
                    "Vamos a intentarlo de nuevo!",
                    "Necesito un correo electrónico válido para conectarte con fábricas + leads.",
                    "Asegúrate de usar el formato de correo electrónico.",
                    <span>¿Crees que ya tienes una cuenta? <a href="/login">Inicia sesión aquí</a>.</span>
                ],
                LunaEmailTakenError: [
                    "¡Ups! Este correo electrónico ya está registrado.",
                    "Por favor usa un correo electrónico diferente o inicia sesión en tu cuenta existente.",
                ],
                emailLabel: "¿Cuál es tu correo electrónico?",
                emailPlaceholder: "tu-marca-email@ejemplo.com",
                passwordLabel: "Elige una contraseña (mínimo 6 caracteres)",
                passwordPlaceholder: "••••••••",
                nextStepsInfo: "Después de registrarte, configurarás tu primer proyecto o irás directamente a tu panel de control.",
                joinButtonLabel: "Únete gratis",
                or: "o",
                googleButtonLabel: "Iniciar sesión con Google",
                termsNoticePrefix: "Al registrarte aceptas los",
                termsAndConditions: "términos y condiciones",
            },
            stepProject: {
                Luna: [
                    'Bienvenido!',
                    "Ahora, vamos a regresar a tu producto...",
                ],
                projetInputPlaceholder: "Agregar un nombre",
                projectInputCategory: "Agregar la categoría del producto",
                projectHelper: "Cuéntanos el tipo de producto específico",
                urgency: "¿Cuál es tu nivel de urgencia?",
                urgencyOptions: [
                    { key: "not_sure", label: "No estoy seguro" },
                    { key: "getting_quotes", label: "Obteniendo cotizaciones y precios" },
                    { key: "need_supplier_asap", label: "Necesito un nuevo proveedor lo antes posible" },
                ],
                lastStep: "El último paso es el siguiente...",
                selectCategory: "Seleccionar una categoría",
                selectLocation: "Seleccionar ubicación",
                selectManufacturingRegion: "Selecciona tu región de fabricación preferida.",
                desiredOrderQuantity: "Cantidad de pedido deseada",
                howManyUnitsYouPlanToProduce: "Cuántas unidades planeas producir.",
                idealPriceYouWouldLikeToPayPerUnit: "El precio ideal que te gustaría pagar por unidad.",
                helpsFactoriesAlignOnMaterialsAndPricing: "Ayuda a las fábricas a alinearse en materiales y precios",
                whereWillYourGoodsBeShipped: "¿Dónde se enviarán tus productos?",
                optionalSpecialInstructions: "Instrucciones especiales opcionales...",
                optionalSpecialInstructionsPlaceholder: "Instrucciones especiales de embalaje o envío...",
                productContextTitle: "Contexto del producto",
                productContextDescription: "Detalles sobre lo que estás buscando y cómo está posicionado.",
                selectMarketSegment: "Seleccionar segmento de mercado",
                weWillMatchYouWithFactoriesThatServeThisMarket: "Te conectaremos con fábricas que sirven a este mercado.",
                factoriesMayAlsoMake: "Las fábricas también pueden fabricar....",
                factoriesMayAlsoMakePlaceholder: "Palabras clave opcionales para refinar el tipo de fábrica...",
                factoriesToAvoid: "Fábricas a evitar",
                listIfApplicable: "Listar si aplica",
                referenceBrands: "Marcas de referencia",
                factoryPreferencesTitle: "Preferencias de fábrica",
                factoryPreferencesDescription: "Filtraremos fábricas que cumplan con tus estándares de cumplimiento o calidad.",
                weWillFilterForYourNeeds: "Filtraremos según tus necesidades.",
            },
        },
        noimages: "No hay imágenes para mostrar",
        brandRfq: {
            aiChat: {
                loading: "Cargando...",
                error: (error) => `Error: ${error?.message || 'No hay datos disponibles del RFQ'}`,
                selectCategory: "Seleccionar categoría",
                selectIdealOrderQuantityMessage: "Establecer una cantidad de pedido deseada es muy importante para atraer proveedores.",
                selectIdealOrderQuantity: "Seleccionar cantidad de pedido ideal",
                selectLocation: "Seleccionar ubicación",
                selectLocationMessage: "También es importante elegir una ubicación preferida para la fabricación.",
                certificationsMessage: "También podés seleccionar qué certificaciones son importantes para vos.",
                selectCertifications: "Seleccionar certificaciones",
                urgencyMessage: "¿Cuál es tu nivel de urgencia?",
                urgencyOptions_not_sure: "No estoy seguro/a",
                urgencyOptions_getting_quotes: "Obteniendo cotizaciones y precios",
                urgencyOptions_need_supplier_asap: "Necesito un nuevo proveedor lo antes posible",
            },
            billOfMaterials: {
                title: "Lista de materiales (Bill of Materials)",
                subtitle: "Detalles exactos de las capacidades y procesos necesarios.",
                cardSubtitle: "Especificaciones",
                quantityNeeded: "Cantidad necesaria por producto",
            },
            sourcingNeeds: {
                title: "Necesidades de abastecimiento",
                subtitle: "Detalles exactos de las capacidades y procesos necesarios.",
                cardTitle: "Necesidad de abastecimiento",
                noDescription: "No se proporcionó una descripción",
            },
            rfqInfoTable: {
                needs: "Necesidades",
                desiredOrderQuantity: "Cantidad de pedido deseada",
                category: "Categoría",
                subCategory: "Subcategoría",
                locationPreferences: "Preferencias de ubicación",
                desiredCertifications: "Certificaciones deseadas",
            },
            withAI: {
                title: "Asegurémonos de que todo se vea correcto",
                subtitle: "Esto es exactamente lo que verán las fábricas verificadas. Asegurate de que todo esté bien antes de enviar.",
                aboutTheCompany: "Sobre la empresa",
                yearsInBusiness: "Años en el negocio",
                businessSize: "Tamaño de la empresa",
                marketSegment: "Segmento de mercado",
                similarBrands: "Marcas similares",
                loading: "Cargando...",
                urgentRequest: "Solicitud urgente",
                highMoq: "MOQ alto (cantidad mínima de pedido)",
                viewAll: "Ver todo",
                downloadAll: "Descargar todo",
                addFiles: "Agregar archivos",
                uploading: "Subiendo...",
            },
            noAi: {
                submissionLimit: (rfqLimitTracker) => `Límite de envío de RFQ - Plan ${rfqLimitTracker.tier_name}`,
                upgradeYourPlan: "Actualizá tu plan",
                submitMoreRFQs: "para enviar más RFQs",
                createProductRFQ: "Nearshore RFQ",
                tellUsAboutYourProduct: "Del concepto a la producción: inicia tu solicitud de abastecimiento aquí",
                projectName: "Nombre del proyecto",
                category: "Categoría",
                selectCategory: "Seleccioná una categoría",
                help: "Elegí la categoría principal de tu producto",
                subcategory: "Subcategoría",
                selectSubcategory: "Seleccioná una subcategoría",
                getSpecific: "¡Seamos específicos!",
                productDescription: "Descripción del producto",
                whatDoYouNeedHelpWith: "¿Con qué necesitás ayuda?",
                needHelpSubtitle: "Contanos con qué servicios necesitás ayuda para completar tu producto.",
                doYouHaveYourProductDesignCompleted: "¿Tenés el diseño de tu producto completado?",
                serviceDescription: "Especificaciones, planos, muestra, etc.",
                details: "Detalles...",
                productionServicestitle: "¿Buscás servicios de producción?",
                productionServiceDescription: "Corte/costura, ensamblado, fabricación, etc.",
                yes: "Sí",
                no: "No",
                sourceMaterialsTitle: "¿Necesitás abastecerte de materiales para este producto?",
                sourceMaterialsDescription: "Seleccioná 'no' si ya tenés fuentes de materiales existentes.",
                packagingSupportTitle: "¿Necesitás soporte de empaque?",
                packagingSupportDescription: "Diseño de empaques, pedidos de embalajes y/o materiales de envío, etc.",
                filesTechPacksAndDesignDocumentsTitle: "Archivos, fichas técnicas y documentos de diseño",
                filesTechPacksAndDesignDocumentsDescription: "Si los tenés, subí cualquier especificación, render o documentación de diseño que ayude a abastecer tu producto.",
                inspirationImagesTitle: "Imágenes de inspiración",
                inspirationImagesDescription: "Subí al menos una imagen para enviar con tu RFQ. Puede ser una imagen de un producto similar, una muestra, un dibujo, etc. ¡Cuantas más, mejor!",
                billOfMaterialsTitle: "Lista de materiales (Bill of Materials)",
                billOfMaterialsDescription: "Proporcioná una lista completa de los materiales necesarios para fabricar tu producto.",
                materialName: "Nombre del material",
                materialDescription: "Descripción",
                materialSpecifications: "Especificaciones",
                materialQuantityNeeded: "Cantidad necesaria por producto",
                attributeTitle: "Atributo",
                priorityLow: "Prioridad baja",
                priorityNiceToHave: "Deseable",
                priorityNonNegotiable: "No negociable",
                capabilitiesTitle: "Servicios y capacidades deseadas",
                capabilitiesDescription: "Qué debe poder hacer la fábrica — ej. serigrafía, fundición de metal, bordado. Nos ayuda a filtrar los socios adecuados.",
                enterDesiredServiceOrCapability: "Ingresá un servicio o capacidad deseada",
                addCapability: "Agregar capacidad",
                additionalDetailsTitle: "Detalles adicionales",
                additionalDetailsDescription: "Detalles opcionales para definir mejor el trabajo.",
                selectLocation: "Seleccionar ubicación",
                selectManufacturingRegion: "Seleccioná tu región de fabricación preferida.",
                desiredOrderQuantity: "Cantidad de pedido deseada",
                howManyUnitsYouPlanToProduce: "Cuántas unidades planeás producir.",
                idealPriceYouWouldLikeToPayPerUnit: "Precio ideal que te gustaría pagar por unidad.",
                helpsFactoriesAlignOnMaterialsAndPricing: "Ayuda a las fábricas a alinearse en materiales y precios",
                whereWillYourGoodsBeShipped: "¿A dónde se enviarán tus productos?",
                optionalSpecialInstructions: "Instrucciones especiales opcionales...",
                optionalSpecialInstructionsPlaceholder: "Instrucciones especiales de empaque o envío...",
                productContextTitle: "Contexto del producto",
                productContextDescription: "Detalles sobre lo que estás buscando y cómo se posiciona.",
                selectMarketSegment: "Seleccionar segmento de mercado",
                weWillMatchYouWithFactoriesThatServeThisMarket: "Te conectaremos con fábricas que sirvan a este mercado.",
                factoriesMayAlsoMake: "Las fábricas también pueden fabricar...",
                factoriesMayAlsoMakePlaceholder: "Palabras clave opcionales para refinar el tipo de fábrica...",
                factoriesToAvoid: "Fábricas a evitar",
                listIfApplicable: "Listar si aplica",
                referenceBrands: "Marcas de referencia",
                factoryPreferencesTitle: "Preferencias de fábrica",
                factoryPreferencesDescription: "Filtraremos fábricas que cumplan tus estándares de calidad o cumplimiento.",
                weWillFilterForYourNeeds: "Filtraremos según tus necesidades.",
            },
            certificationsTags:{
                selectMultiple: "Seleccionar múltiples",
            }
        }
    },
    fr: {
        readyToConnect: "Vous êtes sur le point de vous connecter !",
        greatNews: "Bonne nouvelle ! Vous êtes sur le point d'échanger vos coordonnées. C'est la première étape vers un partenariat réussi. 🎉",
        quickReminder: "UN RAPPEL RAPIDE",
        reportOrderReminder: "Si cette connexion mène à une commande, veuillez nous le signaler sur la plateforme en cliquant sur le bouton \"Signaler une commande\" à côté de la boîte de réception.",
        platformSafety: "Cela maintient notre plateforme à l'abri des arnaques, vous permet de recevoir des avis vérifiés et construit votre score de confiance (de plus, cela fait partie de nos directives communautaires).",
        transparencyNote: "La transparence fait la magie - merci de faire partie de Nearshore !",
        cancel: "Annuler",
        shareContactInfo: "Partager les coordonnées",
        readyToExchange: "Prêt à échanger vos coordonnées ?",
        secureExperience: "Nous nous engageons à garantir que votre expérience avec notre plateforme nearshoring soit sûre et transparente.",
        pleaseAgree: "Veuillez accepter nos",
        termsAndConditions: "Conditions générales",
        toProceed: "pour continuer.",
        agreeToTerms: "Accepter d'échanger les coordonnées",
        shortAgree: "Accepter",
        isReadyToExchange: "est prêt à échanger des coordonnées avec vous !",
        optIn: "Acceptez nos",
        thankYou: "Merci d'avoir accepté les conditions générales de la plateforme.",
        rememberToReport: "N'oubliez pas, si une commande a lieu, appuyez sur le bouton Signaler la commande.",
        hitEnterToSend: "Écrivez un message... (Ctrl + Entrée pour envoyer)",
        pleaseRespondToRequest: "Veuillez répondre à la demande en attente avant d'envoyer d'autres messages",
        supplierPendingIntroRequest: "Votre Demande d'Introduction est en Attente. Une fois acceptée, vous pourrez répondre !",
        attachRFQ: "Joindre RFQ",
        send: "Envoyer",
        createFirstRFQ: "Créez votre premier RFQ",
        attachOneRFQ: "Joignez l'un de vos RFQs",
        createAndSubmit: "Créez et soumettez un RFQ pour le joindre à une conversation.",
        attach: "Joindre",
        toShowContactInfoTo: "avec",
        theOtherParty: "l'autre partie",
        modalAgreeToTerms: "Accepter les conditions",
        shareFile: "Partager un fichier",
        introCenterTitle: "centre de présentation",
        introCenterSubtitle: "Lorsque vous marquez un projet comme intéressant, notre équipe sera informée et nous vous mettrons en contact avec l'acheteur s'il vous convient.",
        filterByCategory: "Filtrer par catégorie",
        allProjects: "Tous les projets",
        myProjects: "Mes projets",
        interestButtonLabel: "je suis intéressé",
        projectName: "Nom du projet",
        category: "Catégorie",
        interest: "Intérêt",
        paywallTitle: "Vous avez utilisé vos Intros Gratuits",
        paywallSubscribedTitle: "Vous avez utilisé votre crédit d'introduction pour ce mois",
        paywallTopVerifiedTitle: "Vous avez atteint votre limite de demandes d'introduction",
        paywallTopVerifiedSubtitle: "Votre compte inclut 30 demandes d'introduction par mois",
        paywallTopVerifiedItem1: "Votre prochaine demande sera disponible le",
        paywallTopVerifiedItem2: "Vous avez le classement de recherche le plus élevé et le badge vérifié",
        paywallTopVerifiedItem3: "Support premium et révision prioritaire de vos demandes",
        paywallSubtitle: "Vous obtenez une introduction de produit gratuite par mois - Effectuez une mise à niveau pour débloquer jusqu'à 30 introductions par mois et vous connecter à plus de marques.",
        paywallSuscribedSubtitle: "Mettez à jour votre plan pour débloquer des Intros illimités et vous connecter à plus de marques.",
        paywallButton: "Explorez nos plans",
        paywallItem1: "Vous obtenez de 10 à 30 Offres de RFQs par mois sur les plans payants",
        paywallSubscribedItem1: "Vous obtenez 10 introductions avec un plan Verifié et jusqu'à 30 par mois avec le plan Top Verifié",
        paywallItem2: "Faites monter votre profil de fonderie avec le meilleur classement de recherche",
        paywallSubscribedItem2: "Faites monter votre profil de fonderie avec le meilleur classement de recherche et la badge de vérification",
        paywallItem3: "Envoyez des messages à d'autres fournisseurs et présentez votre entreprise aux marques",
        paywallSubscribedItem3: "Accès à la recherche de fournisseurs pour trouver des matériaux et des sous-traitants",
        reachOutTitle: "Vous êtes sur le point de prendre contact",
        reachOutSubtitle: "Tu montres de l'intérêt pour cette marque. Dis-leur pourquoi tu corresponds parfaitement.",
        reachOutHelperText: "Parlez brièvement de votre usine, de ce que vous savez faire ou de votre expérience.",
        creditsAvailable: " ",
        startZoomCall: "Démarrer un appel Zoom",
        submitForCredit: "Soumettre",
        submit: "Envoyer",
        introMade: "Introduction faite",
        requestSent: "Demande envoyée",
        removeInterest: "Supprimer l'intérêt",
        cancelRequest: "Annuler",
        introductionRequest: "Demande de présentation",
        waitingForResponse: "En attente de réponse",
        requestDeclined: "Une demande d'introduction a été refusée car elle ne correspond pas au projet",
        requestRemoved: "Une demande d'introduction a été supprimée car elle n'est plus active",
        requestReported: "Votre signalement a été reçu : merci d'aider à maintenir Nearshore sûr et fiable.",
        reportOp1: "Information inexacte ou trompeuse",
        reportOp2: "Contenu ou comportement inapproprié",
        reportOp3: "Activité suspecte ou spam",
        reportOp4: "Concernement de la propriété intellectuelle",
        reportOp5: "Ne correspond pas à nos capacités",
        reportOp6: "Autre",
        reportPlaceholder: "Veuillez expliquer",
        reportTitle: "Signaler le profil",
        reportSubtitle: "Aidez-nous à maintenir Nearshore sûr et fiable.",
        reportSubtitleContinue: "Expliquez-nous pourquoi vous souhaitez signaler ce profil:",
        declinedRequest: "Rejeter la demande",
        message: "Message:",
        thankYouForReport: "Merci pour votre signalement. Nous l'examinerons sous peu.",
        upgradeToAccept: "Passez à premium pour accepter",
        acceptRequest: "Accepter",
        acceptIntroduction: "Accepter l'introduction",
        respondToPendingFirst: "Veuillez répondre à vos demandes d'introduction en attente",
        yourTopMatches: "Vos Meilleures Correspondances",
        topMatchesExplanation: "Nous les avons rassemblées en fonction du profil de votre usine. Pour améliorer les correspondances, mettez à jour vos catégories et MOQ dans votre profil.",
        invoice: {
            buttonLabel: "Envoyer une facture",
            title: "Nouvelle facture",
            reviewTitle: "Vérifier la facture",
            viewAndPay: "Voir et payer",
            companyAddress: "ADRESSE DE L’ENTREPRISE",
            orderNumber: "Numéro de facture (optionnel)",
            productDescription: "Description du produit",
            qty: "Quantité",
            price: "Prix",
            subtotal: "Sous-total",
            tax: "Taxe",
            totalEstimate: "Total de la facture",
            saveAndReview: "Enregistrer et vérifier",
            orderNotes: "Notes (optionnel)",
            productDescriptionPlaceholder: "Insérer le nom du produit",
            orderNotesPlaceholder: "Ajoutez des notes supplémentaires, instructions de paiement, etc. ici",
            customerAddress: "Adresse du client",
            orderNo: "Facture #",
            dateSent: "Date d'envoi",
            customerInfo: "Informations du client",
            messageTitle: "Facture",
            detailTitle: "Facture",
            orderNumberUnavailable: "Le numéro de facture est déjà utilisé",
            from: "De",
            to: "A",
            lineItems: "Articles",
            invoiceNumber: "Facture #",
            invoiceDate: "Date de la facture",
            invoiceTotal: "Total de facture",
            invoiceStatus: "Statut de facture",
            paymentInstructions: "Instructions de paiement",
            notes: "Notes",
            memo: "Memo",
            total: "Total",
            dueDate: "Date d'échéance",
            orderItems: "Articles",
            productError: "La description ne peut pas être vide",
            priceError: "Le prix doit être supérieur à 0",
            quantityError: "La quantité doit être supérieure à 0",
            noActiveConversation: "Impossible de créer une facture sans conversation active. Veuillez attendre que l'autre partie réponde.",
            payInvoice: "Payer la facture",
            paid: "Payée",
            viewReceipt: "Voir le reçu",
            processing: "Traitement...",
            paymentProcessingNote: "Le paiement est en cours de traitement. Veuillez patienter ou actualiser pour voir le statut.",
            addItem: "Ajouter un article",
            itemSingular: "article",
            itemPlural: "articles",
        },
        view: "Voir",
        introCenter: {
            noAiMatchesFound: "Aucune correspondance d'IA trouvée encore",
            aiMatchingDescription: "Notre système d'IA vous met en relation avec des projets pertinents en fonction de votre profil. Complétez ces sections pour améliorer vos correspondances:",
            aiInfoTitle: "Informations de base",
            aiInfoSubtitle: "Détails de l'entreprise, emplacement et informations de contact",
            aiCapabilitiesTitle: "Capacités",
            aiCapabilitiesSubtitle: "Services que vous offrez et capacité de production",
            aiProductTypesTitle: "Types de produits",
            aiProductTypesSubtitle: "Ce que vous fabriquez et spécialisez",
            aiImagesTitle: "Images",
        },
        attributeTag: {
            highMoq: "MOQ élevé",
            urgentRequest: "Demande urgente",
            premiumBrand: "Marque premium",
        },
        capabilities: {
            productDesign: "Développement de produit",
            production: "Production",
            materials: "Matériaux",
            packingAndFulfillment: "Emballage et livraison",
        },
        inbox: {
            filters: {
                selectStatus: "Sélectionner le statut",
                all: "Tous",
                discussingProject: "Discussion du projet",
                quoting: "Devis",
                sampling: "Échantillonnage",
                production: "Production",
                notAFit: "Inadapté",
                closed: "Fermé",
                default: "actif",
                pending: "En attente",
                declined: "Refusé",
                accepted: "Accepté",
            },
            filterByStatus: "Filtrer par statut",
            reportOrder: "Rapport de commande",
            searchPlaceholder: "Rechercher des conversations ou RFQs",
            messages: "Messages",
            pinned: "Épinglé",
            download: "Télécharger",
            view: "Voir",
            viewProfile: "Voir le profil",
            menu: {
                settings: "Configuraciones",
                plans: "Planes",
                helpCenter: "Centro de ayuda",
            },
            months: "mo",
            justNow: "juste maintenant",
            ago: "après"
        },
        brandSignup: {
            step1: {
                title1: "Créez un compte Nearshore gratuit",
                title2: "",
                Luna: [
                    "Voici ce que vous obtenez en rejoignant:",
                    "✓ Accès à plus de 5000 usines vérifiées dans les Amériques et en Europe",
                    "✓ Correspondance basée sur votre produit",
                    "✓ Démarrez votre projet de sourcing instantanément",
                ],
                LunaEmailError: [
                    "Réessayer!",
                    "Je besoin d'un email valide pour vous connecter avec des fonderies + leads.",
                    "Assurez-vous d'utiliser le format d'email correct.",
                    <span>Vous pensez avoir déjà un compte? <a href="/login">Connectez-vous ici</a>.</span>
                ],
                LunaEmailTakenError: [
                    "Oups! Cet email est déjà enregistré.",
                    "Veuillez utiliser un email différent ou vous connecter à votre compte existant.",
                ],
                emailLabel: "Quel est votre email?",
                emailPlaceholder: "votre-marque-email@exemple.com",
                passwordLabel: "Choisissez un mot de passe (minimum 6 caractères)",
                passwordPlaceholder: "••••••••",
                nextStepsInfo: "Après l'inscription, vous configurerez votre premier projet ou accéderez directement à votre tableau de bord.",
                joinButtonLabel: "Rejoindre gratuitement",
                or: "ou",
                googleButtonLabel: "Se connecter avec Google",
                termsNoticePrefix: "En vous inscrivant, vous acceptez les",
                termsAndConditions: "conditions générales",
            },
            stepProject: {
                Luna: [
                    (name) => `Bienvenue, ${name}!`,
                    "Maintenant, revenons à votre produit...",
                ],
                projetInputPlaceholder: "Ajouter un nom",
                projectInputCategory: "Ajouter la catégorie du produit",
                projectHelper: "Dites-nous le type de produit spécifique",
                urgency: "Quel est votre niveau d'urgence?",
                urgencyOptions: [
                    { key: "not_sure", label: "Pas sûr" },
                    { key: "getting_quotes", label: "Obtenir des devis et des prix" },
                    { key: "need_supplier_asap", label: "Besoin d'un nouveau fournisseur dès maintenant" },
                ],
                lastStep: "Le dernier pas est le suivant...",
                selectCategory: "Sélectionner une catégorie",
                selectLocation: "Sélectionner l'emplacement",
                selectManufacturingRegion: "Sélectionnez votre région de fabrication préférée.",
                desiredOrderQuantity: "Quantité de commande souhaitée",
                howManyUnitsYouPlanToProduce: "Combien d'unités prévoyez-vous de produire.",
                idealPriceYouWouldLikeToPayPerUnit: "Le prix idéal que vous aimeriez payer par unité.",
                helpsFactoriesAlignOnMaterialsAndPricing: "Aide les usines à s'aligner sur les matériaux et les prix",
                whereWillYourGoodsBeShipped: "Où vos marchandises seront-elles expédiées?",
                optionalSpecialInstructions: "Instructions spéciales optionnelles...",
                optionalSpecialInstructionsPlaceholder: "Instructions spéciales d'emballage ou d'expédition...",
                productContextTitle: "Contexte du produit",
                productContextDescription: "Détails sur ce que vous recherchez et comment il est positionné.",
                selectMarketSegment: "Sélectionner le segment de marché",
                weWillMatchYouWithFactoriesThatServeThisMarket: "Nous vous mettrons en relation avec des usines qui servent ce marché.",
                factoriesMayAlsoMake: "Les usines peuvent également fabriquer....",
                factoriesMayAlsoMakePlaceholder: "Mots-clés optionnels pour affiner le type d'usine...",
                factoriesToAvoid: "Usines à éviter",
                listIfApplicable: "Liste si applicable",
                referenceBrands: "Marques de référence",
                factoryPreferencesTitle: "Préférences d'usine",
                factoryPreferencesDescription: "Nous filtrerons les usines qui répondent à vos normes de conformité ou de qualité.",
                weWillFilterForYourNeeds: "Nous filtrerons selon vos besoins.",
            }
        },
        noimages: "Ne pas d'images à afficher",
        brandRfq: {
            aiChat: {
                loading: "Chargement...",
                error: (error) => `Erreur : ${error?.message || 'Aucune donnée RFQ disponible'}`,
                selectCategory: "Sélectionner une catégorie",
                selectIdealOrderQuantityMessage: "Définir une quantité de commande souhaitée est très important pour attirer les fournisseurs.",
                selectIdealOrderQuantity: "Sélectionner la quantité de commande idéale",
                selectLocation: "Sélectionner un lieu",
                selectLocationMessage: "Il est également important de choisir un lieu de fabrication préféré.",
                certificationsMessage: "Vous pouvez également sélectionner les certifications qui sont importantes pour vous.",
                selectCertifications: "Sélectionner des certifications",
                urgencyMessage: "Quel est votre niveau d'urgence ?",
                urgencyOptions_not_sure: "Pas sûr",
                urgencyOptions_getting_quotes: "Obtention de devis et de prix",
                urgencyOptions_need_supplier_asap: "Besoin d’un nouveau fournisseur dès que possible",
            },
            billOfMaterials: {
                title: "Liste des matériaux (Bill of Materials)",
                subtitle: "Détails exacts des capacités et des processus nécessaires.",
                cardSubtitle: "Spécifications",
                quantityNeeded: "Quantité nécessaire par produit",
            },
            sourcingNeeds: {
                title: "Besoins en approvisionnement",
                subtitle: "Détails exacts des capacités et des processus nécessaires.",
                cardTitle: "Besoin en approvisionnement",
                noDescription: "Aucune description fournie",
            },
            rfqInfoTable: {
                needs: "Besoins",
                desiredOrderQuantity: "Quantité de commande souhaitée",
                category: "Catégorie",
                subCategory: "Sous-catégorie",
                locationPreferences: "Préférences de lieu",
                desiredCertifications: "Certifications souhaitées",
            },
            withAI: {
                title: "Assurons-nous que tout semble correct",
                subtitle: "Voici exactement ce que verront les usines vérifiées. Vérifiez avant d’envoyer.",
                aboutTheCompany: "À propos de l’entreprise",
                yearsInBusiness: "Années d’activité",
                businessSize: "Taille de l’entreprise",
                marketSegment: "Segment de marché",
                similarBrands: "Marques similaires",
                loading: "Chargement...",
                urgentRequest: "Demande urgente",
                highMoq: "MOQ élevé (quantité minimale de commande)",
                viewAll: "Tout voir",
                downloadAll: "Tout télécharger",
                addFiles: "Ajouter des fichiers",
                uploading: "Téléchargement...",
            },
            noAi: {
                submissionLimit: (rfqLimitTracker) => `Limite de soumission RFQ - Plan ${rfqLimitTracker.tier_name}`,
                upgradeYourPlan: "Mettre à niveau votre plan",
                submitMoreRFQs: "pour soumettre plus de RFQ",
                createProductRFQ: "Nearshore RFQ",
                tellUsAboutYourProduct: "Du concept à la production — lancez votre demande d'approvisionnement ici",
                projectName: "Nom du projet",
                category: "Catégorie",
                selectCategory: "Sélectionner une catégorie",
                help: "Choisissez la catégorie principale de votre produit",
                subcategory: "Sous-catégorie",
                selectSubcategory: "Sélectionner une sous-catégorie",
                getSpecific: "Soyons précis !",
                productDescription: "Description du produit",
                whatDoYouNeedHelpWith: "Avec quoi avez-vous besoin d’aide ?",
                needHelpSubtitle: "Dites-nous quels services vous sont nécessaires pour finaliser votre produit.",
                doYouHaveYourProductDesignCompleted: "Votre conception de produit est-elle terminée ?",
                serviceDescription: "Spécifications, plans, échantillon, etc.",
                details: "Détails...",
                productionServicestitle: "Cherchez-vous des services de production ?",
                productionServiceDescription: "Coupe/couture, assemblage, fabrication, etc.",
                yes: "Oui",
                no: "Non",
                sourceMaterialsTitle: "Avez-vous besoin de vous approvisionner en matériaux pour ce produit ?",
                sourceMaterialsDescription: "Sélectionnez 'non' si vous disposez déjà de sources de matériaux.",
                packagingSupportTitle: "Avez-vous besoin d’un soutien pour l’emballage ?",
                packagingSupportDescription: "Conception d’emballages, commande de matériaux d’emballage et/ou d’expédition, etc.",
                filesTechPacksAndDesignDocumentsTitle: "Fichiers, fiches techniques et documents de conception",
                filesTechPacksAndDesignDocumentsDescription: "Si vous en avez, téléversez toute spécification, rendu ou documentation de conception pour aider à l’approvisionnement.",
                inspirationImagesTitle: "Images d’inspiration",
                inspirationImagesDescription: "Téléversez au moins une image à soumettre avec votre RFQ. Cela peut être une image d’un produit similaire, un échantillon, un dessin, etc. Plus il y en a, mieux c’est.",
                billOfMaterialsTitle: "Liste des matériaux (Bill of Materials)",
                billOfMaterialsDescription: "Veuillez fournir une liste complète des matériaux nécessaires à la fabrication de votre produit.",
                materialName: "Nom du matériau",
                materialDescription: "Description",
                materialSpecifications: "Spécifications",
                materialQuantityNeeded: "Quantité nécessaire par produit",
                attributeTitle: "Attribut",
                priorityLow: "Priorité basse",
                priorityNiceToHave: "Souhaitable",
                priorityNonNegotiable: "Non négociable",
                capabilitiesTitle: "Services et capacités souhaités",
                capabilitiesDescription: "Ce que l’usine doit savoir faire — ex. sérigraphie, moulage du métal, broderie. Nous aide à filtrer les bons partenaires.",
                enterDesiredServiceOrCapability: "Entrez un service ou une capacité souhaitée",
                addCapability: "Ajouter une capacité",
                additionalDetailsTitle: "Détails supplémentaires",
                additionalDetailsDescription: "Détails optionnels pour mieux définir le travail.",
                selectLocation: "Sélectionner un lieu",
                selectManufacturingRegion: "Sélectionnez votre région de fabrication préférée.",
                desiredOrderQuantity: "Quantité de commande souhaitée",
                howManyUnitsYouPlanToProduce: "Combien d’unités prévoyez-vous de produire.",
                idealPriceYouWouldLikeToPayPerUnit: "Prix idéal que vous souhaitez payer par unité.",
                helpsFactoriesAlignOnMaterialsAndPricing: "Aide les usines à s’aligner sur les matériaux et les prix",
                whereWillYourGoodsBeShipped: "Où vos produits seront-ils expédiés ?",
                optionalSpecialInstructions: "Instructions spéciales optionnelles...",
                optionalSpecialInstructionsPlaceholder: "Instructions spéciales d’emballage ou d’expédition...",
                productContextTitle: "Contexte du produit",
                productContextDescription: "Détails sur ce que vous recherchez et comment c’est positionné.",
                selectMarketSegment: "Sélectionner un segment de marché",
                weWillMatchYouWithFactoriesThatServeThisMarket: "Nous vous mettrons en relation avec des usines qui desservent ce marché.",
                factoriesMayAlsoMake: "Les usines peuvent également fabriquer...",
                factoriesMayAlsoMakePlaceholder: "Mots-clés optionnels pour affiner le type d’usine...",
                factoriesToAvoid: "Usines à éviter",
                listIfApplicable: "Lister si applicable",
                referenceBrands: "Marques de référence",
                factoryPreferencesTitle: "Préférences d’usine",
                factoryPreferencesDescription: "Nous filtrerons les usines qui respectent vos normes de conformité ou de qualité.",
                weWillFilterForYourNeeds: "Nous filtrerons selon vos besoins.",
            },
            certificationsTags:{
                selectMultiple: "Sélectionner multiples",
            }
        }

    },
    pt: {
        readyToConnect: "Você está prestes a se conectar!",
        greatNews: "Ótima notícia! Você está prestes a trocar informações de contato. Este é o primeiro passo para construir uma parceria de sucesso. 🎉",
        quickReminder: "UM LEMBRETE RÁPIDO",
        reportOrderReminder: "Se esta conexão resultar em um pedido, informe-nos na plataforma clicando no botão \"Reportar Pedido\" ao lado da caixa de entrada.",
        platformSafety: "Mantém nossa plataforma segura contra fraudes, permite que você receba avaliações verificadas e constrói sua pontuação de confiança (além disso, faz parte de nossas diretrizes da comunidade).",
        transparencyNote: "A transparência faz a mágica acontecer - obrigado por fazer parte do Nearshore!",
        cancel: "Cancelar",
        shareContactInfo: "Compartilhar informações de contato",
        readyToExchange: "Pronto para trocar informações de contato?",
        secureExperience: "Estamos comprometidos em garantir que sua experiência com nossa plataforma de nearshoring seja segura e transparente.",
        pleaseAgree: "Por favor, concorde com nossos",
        termsAndConditions: "Termos e Condições",
        toProceed: "para continuar.",
        agreeToTerms: "Concordar em trocar informações de contato",
        shortAgree: "Concordar",
        isReadyToExchange: "está pronto para trocar informações de contato com você!",
        optIn: "Opte por concordar com nossos",
        thankYou: "Obrigado por concordar com os termos gerais da plataforma.",
        rememberToReport: "Lembre-se, se um pedido ocorrer, pressione o botão de reportar pedido.",
        hitEnterToSend: "Escreva uma mensagem... (Ctrl + Enter para enviar)",
        pleaseRespondToRequest: "Por favor, responda à solicitação pendente antes de enviar mais mensagens",
        supplierPendingIntroRequest: "Sua Solicitação de Introdução está Pendente. Uma vez aceita, você poderá responder!",
        attachRFQ: "Anexar RFQ",
        send: "Enviar",
        createFirstRFQ: "Crie seu primeiro RFQ",
        attachOneRFQ: "Anexe um de seus RFQs",
        createAndSubmit: "Crie e envie um RFQ para anexá-lo a uma conversa.",
        attach: "Anexar",
        toShowContactInfoTo: "com",
        theOtherParty: "a outra parte",
        modalAgreeToTerms: "Aceitar termos",
        shareFile: "Compartilhar arquivo",
        introCenterTitle: "centro de introdução",
        introCenterSubtitle: "Quando você marca um projeto como interessante, nossa equipe será notificada e conectará você ao comprador, caso seja uma boa opção.",
        filterByCategory: "Filtrar por categoria",
        allProjects: "Todos os projetos",
        myProjects: "Meus projetos",
        interestButtonLabel: "estou interessado",
        projectName: "Nome do projeto",
        category: "Categoria",
        interest: "Interesse",
        paywallTitle: "Você usou suas Intros Grátis",
        paywallSubscribedTitle: "Você usou seu Crédito de Introdução para este mês",
        paywallTopVerifiedTitle: "Você atingiu seu limite de solicitações de introdução",
        paywallTopVerifiedSubtitle: "Sua conta inclui 30 solicitações de introdução por mês",
        paywallTopVerifiedItem1: "Sua próxima solicitação estará disponível em",
        paywallTopVerifiedItem2: "Você tem o ranking de busca mais alto e badge verificado",
        paywallTopVerifiedItem3: "Suporte premium e revisão prioritária de suas solicitações",
        paywallSuscribedSubtitle: "Atualize seu plano para desbloquear Intros ilimitadas e conectar com mais marcas.",
        paywallSubtitle: "Você recebe uma introdução de produto por mês gratuitamente — atualize para desbloquear até 30 Intros por mês e conectar com mais marcas.",
        paywallButton: "Explore nossos planos",
        paywallItem1: "Você recebe de 10 a 30 solicitações de cotação por mês em planos pagos",
        paywallSubscribedItem1: "Você recebe 10 introduções com um plano Verificado e até 30 por mês com o plano Top Verificado",
        paywallItem2: "Impulse seu perfil de fábrica com o melhor ranking de busca",
        paywallSubscribedItem2: "Impulse seu perfil de fábrica com o melhor ranking de busca e a badge de verificação",
        paywallItem3: "Envie mensagens para outros fornecedores e apresente sua empresa à marcas",
        paywallSubscribedItem3: "Acesse a busca de fornecedores para encontrar materiais e subcontratistas",
        reachOutTitle: "Você está prestes a entrar em contato",
        reachOutSubtitle: "Você está demonstrando interesse em se conectar com esta marca. Diga a eles por que você é uma ótima opção.",
        reachOutHelperText: "Fale rapidinho sobre sua fábrica, o que você faz bem ou sua experiência.",
        creditsAvailable: " ",
        startZoomCall: "Iniciar uma chamada Zoom",
        submitForCredit: "Submeter",
        submit: "Submeter",
        requestSent: "Solicitação Enviada",
        introMade: "Introdução feita",
        removeInterest: "Remover interesse",
        cancelRequest: "Cancelar",
        introductionRequest: "Solicitação de introdução",
        waitingForResponse: "Aguardando resposta",
        requestDeclined: "Uma solicitação de introdução foi rejeitada porque não é adequada para o projeto",
        requestRemoved: "Uma solicitação de introdução foi removida porque não está mais ativa",
        requestReported: "Seu relatório foi recebido: obrigado por ajudar a manter Nearshore seguro e confiável.",
        reportOp1: "Inaccurate or misleading information",
        reportOp2: "Conteúdo ou comportamento inapropriado",
        reportOp3: "Atividade suspeita ou spam",
        reportOp4: "Problema de propriedade intelectual",
        reportOp5: "Não corresponde a nossas capacidades",
        reportOp6: "Outro",
        reportPlaceholder: "Por favor, explique",
        reportTitle: "Reportar perfil",
        reportSubtitle: "Ajude-nos a manter Nearshore seguro e confiável.",
        reportSubtitleContinue: "Explique-nos por que você está reportando este perfil:",
        declinedRequest: "Rejeitar solicitação",
        message: "Mensagem:",
        thankYouForReport: "Obrigado pelo seu relatório. Vamos analisá-lo em breve.",
        upgradeToAccept: "Passe para premium para aceitar",
        acceptRequest: "Aceitar",
        acceptIntroduction: "Aceitar introdução",
        respondToPendingFirst: "Por favor responda às suas solicitações de introdução pendentes",
        yourTopMatches: "Suas Melhores Correspondências",
        topMatchesExplanation: "Reunimos estas com base no perfil da sua fábrica. Para melhorar as correspondências, atualize suas categorias e MOQ no seu perfil.",
        invoice: {
            buttonLabel: "Enviar uma fatura",
            title: "Nova fatura",
            reviewTitle: "Revisar fatura",
            viewAndPay: "Ver e pagar",
            companyAddress: "ENDEREÇO DA EMPRESA",
            orderNumber: "Número de fatura (opcional)",
            productDescription: "Descrição do produto",
            qty: "Quantidade",
            price: "Preço",
            subtotal: "Subtotal",
            tax: "Imposto",
            totalEstimate: "Total da fatura",
            saveAndReview: "Salvar e revisar",
            orderNotes: "Notas (opcional)",
            productDescriptionPlaceholder: "Insira o nome do produto",
            orderNotesPlaceholder: "Adicione notas adicionais, instruções de pagamento, etc. aqui",
            customerAddress: "Endereço do cliente",
            orderNo: "Fatura #",
            dateSent: "Data de envio",
            customerInfo: "Informações do cliente",
            messageTitle: "Fatura",
            detailTitle: "Fatura",
            orderNumberUnavailable: "O número da fatura já está em uso",
            from: "De",
            to: "A",
            lineItems: "Itens",
            invoiceNumber: "Fatura #",
            invoiceDate: "Data da fatura",
            invoiceTotal: "Total da fatura",
            invoiceStatus: "Status da fatura",
            paymentInstructions: "Instruções de pagamento",
            notes: "Notas",
            memo: "Memo",
            total: "Total",
            dueDate: "Data de vencimento",
            orderItems: "Itens",
            productError: "A descrição não pode estar em branco",
            priceError: "O preço deve ser maior que 0",
            quantityError: "A quantidade deve ser maior que 0",
            noActiveConversation: "Não é possível criar uma fatura sem uma conversa ativa. Aguarde até que a outra parte responda.",
            payInvoice: "Pagar fatura",
            paid: "Paga",
            viewReceipt: "Ver recibo",
            processing: "Processando...",
            paymentProcessingNote: "O pagamento está sendo processado. Aguarde ou atualize para ver o status.",
            addItem: "Adicionar item",
            itemSingular: "item",
            itemPlural: "itens",
        },
        view: "Ver",
        introCenter: {
            noAiMatchesFound: "Nenhuma correspondência de IA encontrada ainda",
            aiMatchingDescription: "Nosso sistema de IA te empareja com projetos relevantes com base em seu perfil. Complete estas seções para melhorar suas correspondências:",
            aiInfoTitle: "Informações básicas",
            aiInfoSubtitle: "Detalhes da empresa, localização e informações de contato",
            aiCapabilitiesTitle: "Capacidades",
            aiCapabilitiesSubtitle: "Serviços que você oferece e capacidade de produção",
            aiProductTypesTitle: "Tipos de produtos",
            aiProductTypesSubtitle: "O que você fabrica e especializa",
            aiImagesTitle: "Imagens",
        },
        attributeTag: {
            highMoq: "MOQ alto",
            urgentRequest: "Solicitação urgente",
            premiumBrand: "Marca premium",
        },
        capabilities: {
            productDesign: "Desenvolvimento de produto",
            production: "Produção",
            materials: "Materiais",
            packingAndFulfillment: "Embalagem e entrega",
        },
        inbox: {
            filters: {
                selectStatus: "Selecionar status",
                all: "Todos",
                discussingProject: "Discutindo projeto",
                quoting: "Orçamento",
                sampling: "Amostragem",
                production: "Produção",
                notAFit: "Não Se Encaixa",
                closed: "Fechado",
                default: "ativo",
                pending: "Pendente",
                declined: "Recusado",
                accepted: "Aceito",
            },
            filterByStatus: "Filtrar por status",
            reportOrder: "Ordem do relatório",
            searchPlaceholder: "Pesquisar conversas ou RFQs",
            messages: "Mensagens",
            pinned: "Fixado",
            download: "Baixar",
            view: "Ver",
            viewProfile: "Ver perfil",
            menu: {
                settings: "Configurações",
                plans: "Planos",
                helpCenter: "Centro de ajuda",
            },
            months: "me",
            justNow: "justo agora",
            ago: "atrás"
        },
        brandSignup: {
            step1: {
                title1: "Crie uma conta Nearshore gratuita",
                title2: "",
                Luna: [
                    "Aqui está o que você ganha ao se juntar:",
                    "✓ Acesso a mais de 5000 fábricas verificadas nas Américas e Europa",
                    "✓ Correspondência baseada no seu produto",
                    "✓ Inicie seu projeto de sourcing instantaneamente",
                ],
                LunaEmailError: [
                    "Vamos tentar novamente!",
                    "Preciso de um email válido para te conectar com fábricas + leads.",
                    "Certifique-se de usar o formato de email correto.",
                    <span>Acha que já tem uma conta? <a href="/login">Entre aqui</a>.</span>
                ],
                LunaEmailTakenError: [
                    "Ops! Este email já está registrado.",
                    "Por favor, use um email diferente ou faça login na sua conta existente.",
                ],
                emailLabel: "Qual é o seu email?",
                emailPlaceholder: "sua-marca-email@exemplo.com",
                passwordLabel: "Escolha uma senha (mínimo de 6 caracteres)",
                passwordPlaceholder: "••••••••",
                nextStepsInfo: "Após se inscrever, você configurará seu primeiro projeto ou irá direto para o seu painel.",
                joinButtonLabel: "Junte-se gratuitamente",
                or: "ou",
                googleButtonLabel: "Conectar com Google",
                termsNoticePrefix: "Ao se inscrever, você concorda com os",
                termsAndConditions: "termos e condições",
            },
            stepProject: {
                Luna: [
                    'Bem-vindo!',
                    "Agora, vamos voltar ao seu produto...",
                ],
                projetInputPlaceholder: "Adicionar um nome",
                projectInputCategory: "Adicionar a categoria do produto",
                projectHelper: "Diga-nos o tipo de produto específico",
                urgency: "Qual é o seu nível de urgência?",
                urgencyOptions: [
                    { key: "not_sure", label: "Não estou certo" },
                    { key: "getting_quotes", label: "Obtendo cotações e preços" },
                    { key: "need_supplier_asap", label: "Preciso de um novo fornecedor o mais rápido possível" },
                ],
                lastStep: "O último passo é o próximo...",
                selectCategory: "Selecionar uma categoria",
                selectLocation: "Selecionar localização",
                selectManufacturingRegion: "Selecione sua região de fabricação preferida.",
                desiredOrderQuantity: "Quantidade de pedido desejada",
                howManyUnitsYouPlanToProduce: "Quantas unidades você planeja produzir.",
                idealPriceYouWouldLikeToPayPerUnit: "O preço ideal que você gostaria de pagar por unidade.",
                helpsFactoriesAlignOnMaterialsAndPricing: "Ajuda as fábricas a se alinharem em materiais e preços",
                whereWillYourGoodsBeShipped: "Para onde seus produtos serão enviados?",
                optionalSpecialInstructions: "Instruções especiais opcionais...",
                optionalSpecialInstructionsPlaceholder: "Instruções especiais de embalagem ou envio...",
                productContextTitle: "Contexto do produto",
                productContextDescription: "Detalhes sobre o que você está procurando e como está posicionado.",
                selectMarketSegment: "Selecionar segmento de mercado",
                weWillMatchYouWithFactoriesThatServeThisMarket: "Vamos conectá-lo com fábricas que atendem a este mercado.",
                factoriesMayAlsoMake: "As fábricas também podem fabricar....",
                factoriesMayAlsoMakePlaceholder: "Palavras-chave opcionais para refinar o tipo de fábrica...",
                factoriesToAvoid: "Fábricas a evitar",
                listIfApplicable: "Listar se aplicável",
                referenceBrands: "Marcas de referência",
                factoryPreferencesTitle: "Preferências de fábrica",
                factoryPreferencesDescription: "Filtraremos fábricas que atendam aos seus padrões de conformidade ou qualidade.",
                weWillFilterForYourNeeds: "Filtraremos de acordo com suas necessidades.",
            },
        },
        noimages: "no hay imágenes para mostrar",
        brandRfq: {
            aiChat: {
                loading: "Carregando...",
                error: (error) => `Erro: ${error?.message || 'Nenhum dado de RFQ disponível'}`,
                selectCategory: "Selecionar categoria",
                selectIdealOrderQuantityMessage: "Definir uma quantidade de pedido desejada é muito importante para atrair fornecedores.",
                selectIdealOrderQuantity: "Selecionar quantidade ideal de pedido",
                selectLocation: "Selecionar local",
                selectLocationMessage: "Também é importante escolher um local preferido para a fabricação.",
                certificationsMessage: "Você também pode selecionar quais certificações são importantes para você.",
                selectCertifications: "Selecionar certificações",
                urgencyMessage: "Qual é o seu nível de urgência?",
                urgencyOptions_not_sure: "Não tenho certeza",
                urgencyOptions_getting_quotes: "Obtendo cotações e preços",
                urgencyOptions_need_supplier_asap: "Preciso de um novo fornecedor o quanto antes",
            },
            billOfMaterials: {
                title: "Lista de Materiais (Bill of Materials)",
                subtitle: "Detalhes exatos sobre as capacidades e processos necessários.",
                cardSubtitle: "Especificações",
                quantityNeeded: "Quantidade necessária por produto",
            },
            sourcingNeeds: {
                title: "Necessidades de fornecimento",
                subtitle: "Detalhes exatos sobre as capacidades e processos necessários.",
                cardTitle: "Necessidade de fornecimento",
                noDescription: "Nenhuma descrição fornecida",
            },
            rfqInfoTable: {
                needs: "Necessidades",
                desiredOrderQuantity: "Quantidade de pedido desejada",
                category: "Categoria",
                subCategory: "Subcategoria",
                locationPreferences: "Preferências de local",
                desiredCertifications: "Certificações desejadas",
            },
            withAI: {
                title: "Vamos garantir que tudo esteja correto",
                subtitle: "Aqui está exatamente o que as fábricas verificadas verão. Verifique se está tudo certo antes de enviar.",
                aboutTheCompany: "Sobre a empresa",
                yearsInBusiness: "Anos de atividade",
                businessSize: "Tamanho da empresa",
                marketSegment: "Segmento de mercado",
                similarBrands: "Marcas semelhantes",
                loading: "Carregando...",
                urgentRequest: "Pedido urgente",
                highMoq: "MOQ alto (quantidade mínima de pedido)",
                viewAll: "Ver tudo",
                downloadAll: "Baixar tudo",
                addFiles: "Adicionar arquivos",
                uploading: "Enviando...",
            },
            noAi: {
                submissionLimit: (rfqLimitTracker) => `Limite de envio de RFQ - Plano ${rfqLimitTracker.tier_name}`,
                upgradeYourPlan: "Atualize seu plano",
                submitMoreRFQs: "para enviar mais RFQs",
                createProductRFQ: "Nearshore RFQ",
                tellUsAboutYourProduct: "Do conceito à produção — comece sua solicitação de fornecimento aqui",
                projectName: "Nome do projeto",
                category: "Categoria",
                selectCategory: "Selecione uma categoria",
                help: "Escolha a categoria principal do seu produto",
                subcategory: "Subcategoria",
                selectSubcategory: "Selecione uma subcategoria",
                getSpecific: "Vamos ser específicos!",
                productDescription: "Descrição do produto",
                whatDoYouNeedHelpWith: "Com o que você precisa de ajuda?",
                needHelpSubtitle: "Conte-nos quais serviços você precisa para concluir seu produto.",
                doYouHaveYourProductDesignCompleted: "O design do seu produto está concluído?",
                serviceDescription: "Especificações, desenhos, amostras, etc.",
                details: "Detalhes...",
                productionServicestitle: "Você está procurando serviços de produção?",
                productionServiceDescription: "Corte/costura, montagem, fabricação, etc.",
                yes: "Sim",
                no: "Não",
                sourceMaterialsTitle: "Você precisa adquirir materiais para este produto?",
                sourceMaterialsDescription: "Selecione 'não' se você já tiver fontes de materiais existentes.",
                packagingSupportTitle: "Você precisa de suporte para embalagem?",
                packagingSupportDescription: "Design de embalagem, pedidos de materiais de embalagem e/ou envio, etc.",
                filesTechPacksAndDesignDocumentsTitle: "Arquivos, fichas técnicas e documentos de design",
                filesTechPacksAndDesignDocumentsDescription: "Se você tiver, envie quaisquer especificações, renderizações ou outros documentos de design que ajudem no fornecimento do seu produto.",
                inspirationImagesTitle: "Imagens de inspiração",
                inspirationImagesDescription: "Envie pelo menos uma imagem para enviar com seu RFQ. Pode ser uma imagem de um produto semelhante, uma amostra, um desenho, etc. Quanto mais, melhor!",
                billOfMaterialsTitle: "Lista de Materiais (Bill of Materials)",
                billOfMaterialsDescription: "Forneça uma lista completa dos materiais necessários para fabricar seu produto.",
                materialName: "Nome do material",
                materialDescription: "Descrição",
                materialSpecifications: "Especificações",
                materialQuantityNeeded: "Quantidade necessária por produto",
                attributeTitle: "Atributo",
                priorityLow: "Prioridade baixa",
                priorityNiceToHave: "Bom ter",
                priorityNonNegotiable: "Não negociável",
                capabilitiesTitle: "Serviços e capacidades desejadas",
                capabilitiesDescription: "O que a fábrica deve ser capaz de fazer — ex.: serigrafia, fundição de metal, bordado. Isso nos ajuda a filtrar os parceiros certos.",
                enterDesiredServiceOrCapability: "Insira um serviço ou capacidade desejada",
                addCapability: "Adicionar capacidade",
                additionalDetailsTitle: "Detalhes adicionais",
                additionalDetailsDescription: "Detalhes opcionais para definir melhor o trabalho.",
                selectLocation: "Selecionar local",
                selectManufacturingRegion: "Selecione sua região de fabricação preferida.",
                desiredOrderQuantity: "Quantidade de pedido desejada",
                howManyUnitsYouPlanToProduce: "Quantas unidades você planeja produzir.",
                idealPriceYouWouldLikeToPayPerUnit: "Preço ideal que você gostaria de pagar por unidade.",
                helpsFactoriesAlignOnMaterialsAndPricing: "Ajuda as fábricas a se alinharem em materiais e preços",
                whereWillYourGoodsBeShipped: "Para onde seus produtos serão enviados?",
                optionalSpecialInstructions: "Instruções especiais opcionais...",
                optionalSpecialInstructionsPlaceholder: "Instruções especiais de embalagem ou envio...",
                productContextTitle: "Contexto do produto",
                productContextDescription: "Detalhes sobre o que você está fornecendo e como ele é posicionado.",
                selectMarketSegment: "Selecionar segmento de mercado",
                weWillMatchYouWithFactoriesThatServeThisMarket: "Vamos conectá-lo com fábricas que atendem a esse mercado.",
                factoriesMayAlsoMake: "As fábricas também podem fabricar...",
                factoriesMayAlsoMakePlaceholder: "Palavras-chave opcionais para refinar o tipo de fábrica...",
                factoriesToAvoid: "Fábricas a evitar",
                listIfApplicable: "Liste se aplicável",
                referenceBrands: "Marcas de referência",
                factoryPreferencesTitle: "Preferências de fábrica",
                factoryPreferencesDescription: "Filtraremos as fábricas que atendem aos seus padrões de conformidade ou qualidade.",
                weWillFilterForYourNeeds: "Filtraremos de acordo com suas necessidades.",
            },
            certificationsTags:{
                selectMultiple: "Selecione vários",
            }
        }
    }
};

export const IDEAL_QUANTITIES = {
    sample_only: "Sample only",
    under_500_units: "Under 500 units",
    between_500_and_2000_units: "500-2000 units",
    between_2000_and_5000_units: "2000-5000 units",
    over_5000_units: "5000+ units",
};
